<template>
  <div class="product-detail-unlimited-subscription">
    <p class="is-size-3 text-center mb-5 product-detail-unlimited-subscription-title">
      {{ productTree.product_detail.withtax_price_per_month.amount / 100 }}
      {{ productTree.product_detail.withtax_price_per_month.currency.symbol }}
      <small class="is-size-5">/ {{ $t('month') }}</small><br>
      <small class="has-text-grey is-size-6">
        {{ productTree.product_detail.number_months_contractual_commitment === 1 ? $t('withoutCommitment') : $t('commitment', { month: productTree.product_detail.number_months_contractual_commitment })}}
      </small>
    </p>
    <p class="text-center pb-2 mb-2">
      {{ productTree.name }}
    </p>
    <unlimited-subscription-cart-btn
      v-if="addToCartBtn"
      :unlimited-subscription-id="productTree.product_detail.id"
    />
  </div>
</template>

<script>
import VueI18n from "vue-i18n";
import { LocaleMixin } from "@/mixins/LocaleMixin";
import UnlimitedSubscriptionCartBtn from "@/components/UnlimitedSubscriptionCartBtn";

export default {
  name: "ProductDetailUnlimitedSubscription",
  components: { UnlimitedSubscriptionCartBtn },
  mixins: [LocaleMixin],
  props: {
    productTree: Object,
    addToCartBtn: {
      type: Boolean,
      default: true
    }
  },

  // Translate component
  mounted() {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        month: "month",
        withoutCommitment: "Without commitment",
        commitment: "%{month} months' commitment"
      },
      fr: {
        month: "mois",
        withoutCommitment: "Sans engagement",
        commitment: "%{month} mois d'engagement"
      }
    }
  })
}
</script>
<style lang="scss">
.product-detail-unlimited-subscription {
  .product-detail-unlimited-subscription-title {
    line-height: 0.8em;
  }
}
</style>
